import { createBrowserRouter } from "react-router-dom";
import Root from "../components/Root";

import NotFound from "../pages/NotFound";
import Order from "../pages/Order";
import Home from "../pages/Home";
import ProgressCheck from "../pages/ProgressCheck";
import ProgressResult from "../pages/ProgressResult";
import Intro from "../pages/Intro";
import Payments from "../pages/Payments";
import PaymentsSMS from "../pages/PaymentsSMS";
import PaymentsCompleted from "../pages/PaymentsCompleted";
import PaymentsExpiration from "../pages/PaymentsExpiration";
import RequestParcelExpiration from "../pages/RequestParcelExpiration";
import RequestParcel from "../pages/RequestParcel";
import RequestParcelCompleted from "../pages/RequestParcelCompleted";
import ParcelContainer from "../pages/ParcelContainer";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Root />,
        children: [
            { path: "", element: <Home /> },
            {
                path: "order",
                element: <Order />,
            },
            {
                path: "progresscheck",
                element: <ProgressCheck />,
            },
            {
                path: "progressresult",
                element: <ProgressResult />,
            },
            {
                path: "intro",
                element: <Intro />,
            },
        ],
        errorElement: <NotFound />,
    },
    {
        path: "/requestparcel",
        element: <ParcelContainer />,
        children: [
            {
                path: "",
                element: <RequestParcel />,
            },
            {
                path: "expiration",
                element: <RequestParcelExpiration />,
            },
            {
                path: "completed",
                element: <RequestParcelCompleted />,
            },
        ],
        errorElement: <NotFound />,
    },
    {
        path: "/oemrequestpay",
        element: <Payments />,
        children: [
            {
                path: "sms",
                element: <PaymentsSMS />,
            },
            {
                path: "expiration",
                element: <PaymentsExpiration />,
            },
        ],
        errorElement: <NotFound />,
    },
    {
        path: "/oemrequestpay/completed",
        element: <PaymentsCompleted />,
    },
]);

export default router;
